<div class="bbox-thumb-wrapper">
    <div [ngStyle]="{ 'height': bboxHeight * scale + 'px',
            'width': bboxWidth * scale + 'px',
            'backgroundColor': colorStr(color, 0.3),
            'borderColor': colorStr(color, 0.8)}"
        class="bbox-thumb"
         *ngIf="scale">
    </div>
</div>